/**
 * Pill.jsx
 * Status badge component and color lookup used across all views.
 *
 * @param {string} label — Status text (e.g. 'On Track', 'Won', 'PTO')
 *
 * statusColor(label) returns { bg, color } for any known status string.
 * Unknown statuses default to grey (#f5f5f5 / #555).
 */

export const statusColor = (s) =>
  ({
    'On Track': { bg: '#E8F5E9', color: '#1B5E20' },
    Review: { bg: '#E3F2FD', color: '#1565C0' },
    'On Hold': { bg: '#FFF3E0', color: '#E65100' },
    Complete: { bg: '#F3E5F5', color: '#6A1B9A' },
    'In Progress': { bg: '#E8F5E9', color: '#1B5E20' },
    Open: { bg: '#F5F5F5', color: '#424242' },
    Scheduled: { bg: '#E3F2FD', color: '#1565C0' },
    'On-Site': { bg: '#E8F5E9', color: '#1B5E20' },
    Office: { bg: '#E8EAF6', color: '#283593' },
    PTO: { bg: '#F5F5F5', color: '#757575' },
    High: { bg: '#FFEBEE', color: '#B71C1C' },
    Medium: { bg: '#FFF8E1', color: '#E65100' },
    Low: { bg: '#E8F5E9', color: '#2E7D32' },
    Won: { bg: '#E8F5E9', color: '#1B5E20' },
    Lost: { bg: '#FFEBEE', color: '#B71C1C' },
    // Q-01: the opportunity status, in the grey 'cancel' token (theme/tokens.js status.cancel)
    Cancelled: { bg: '#F3F4F6', color: '#6B7280' },
    Commissioning: { bg: '#FFF3E0', color: '#E65100' },
    Design: { bg: '#E3F2FD', color: '#1565C0' },
    Proposal: { bg: '#EDE7F6', color: '#4527A0' },
    Engineering: { bg: '#E8F5E9', color: '#1B5E20' },
    Connected: { bg: '#E8F5E9', color: '#1B5E20' },
    Migrated: { bg: '#F3E5F5', color: '#6A1B9A' },
    'Pending Setup': { bg: '#FFF8E1', color: '#F57F17' },
  })[s] ?? { bg: '#f5f5f5', color: '#555' };

export const Pill = ({ label }) => {
  const c = statusColor(label);
  return (
    <span
      style={{
        background: c.bg,
        color: c.color,
        padding: '3px 10px',
        borderRadius: 20,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: 0.3,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
};
